import i18n from 'i18next';
import { stringUtilities } from 'utils';

const NotificationService = {
  getCurrentSubscription: async () => {
    if (!('serviceWorker' in navigator)) return;

    try {
      const registration = await navigator.serviceWorker.ready;

      if (!registration || !registration.pushManager) return null;

      return await registration.pushManager.getSubscription();
    } catch (error) {
      throw error;
    }
  },

  subscribeDevice: async () => {
    if (!('serviceWorker' in navigator)) {
      return;
    }

    if (!('Notification' in window)) {
      throw new Error(i18n.t('services.notificationService.installAppToEnableNotifications'));
    }

    try {
      const permission = await Notification.requestPermission();

      if (permission !== 'granted') {
        throw new Error(i18n.t('services.notificationService.permissionNotGranted'));
      }

      const registration = await navigator.serviceWorker.ready;
      const existingSubscription = await registration.pushManager.getSubscription();

      if (existingSubscription) {
        existingSubscription.unsubscribe();
      }

      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: stringUtilities.urlBase64ToUint8Array(
          process.env.REACT_APP_VAPID_PUBLIC_KEY,
        ),
      });

      return subscription;
    } catch (error) {
      throw error;
    }
  },

  unsubscribeDevice: async () => {
    if (!('serviceWorker' in navigator)) return;

    try {
      const registration = await navigator.serviceWorker.ready;
      const existingSubscription = await registration.pushManager.getSubscription();

      if (existingSubscription) {
        existingSubscription.unsubscribe();
      }
    } catch (error) {
      throw error;
    }
  },
};

export default NotificationService;
